module.exports = __webpack_public_path__ + "static/media/adserver_section1.bdad7296.png";